import { translate } from './translate';
import { hasSubdivisionShippingError, hasZipCodeShippingError } from './calculationError.utils';
import { hasTimeSlotShippingMethods } from './hasTimeSlotShippingMethods';
export function getShippingMethods(checkout, translations) {
  var _checkout$shippingInf;
  if (hasSubdivisionShippingError(checkout) || hasZipCodeShippingError(checkout) || hasTimeSlotShippingMethods(checkout)) {
    return;
  }
  const options = ((_checkout$shippingInf = checkout.shippingInfo) == null || (_checkout$shippingInf = _checkout$shippingInf.carrierServiceOptions) == null ? void 0 : _checkout$shippingInf.flatMap(_ref => {
    let {
      shippingOptions
    } = _ref;
    return shippingOptions;
  })) || [];
  const shippingOptions = options.map(_ref2 => {
    var _cost$price, _logistics$pickupDeta, _logistics$pickupDeta2;
    let {
      title,
      cost,
      code,
      logistics
    } = _ref2;
    return {
      label: title,
      amount: (cost == null || (_cost$price = cost.price) == null ? void 0 : _cost$price.amount) ?? '0',
      identifier: code,
      detail: (logistics == null ? void 0 : logistics.deliveryTime) || (logistics != null && (_logistics$pickupDeta = logistics.pickupDetails) != null && _logistics$pickupDeta.address ? translate(translations, 'cart.delivery_method_picker.pickup_address', toOptions(logistics == null || (_logistics$pickupDeta2 = logistics.pickupDetails) == null ? void 0 : _logistics$pickupDeta2.address)) : '')
    };
  });
  const selectedShippingOption = shippingOptions.findIndex(option => {
    var _checkout$shippingInf2;
    return option.identifier === ((_checkout$shippingInf2 = checkout.shippingInfo) == null || (_checkout$shippingInf2 = _checkout$shippingInf2.selectedCarrierServiceOption) == null ? void 0 : _checkout$shippingInf2.code);
  });
  if (selectedShippingOption !== -1) {
    shippingOptions.unshift(shippingOptions.splice(selectedShippingOption, 1)[0]);
  }
  return shippingOptions;
}
function toOptions(address) {
  if (!address) {
    return {};
  }
  const {
    countryFullname,
    subdivisionFullname,
    addressLine,
    city
  } = address;
  return {
    country: countryFullname,
    subdivision: subdivisionFullname,
    addressLine: addressLine,
    city: city
  };
}
export function getShippingOptions(deliveryOptions, checkout) {
  const {
    errors,
    deliveries
  } = deliveryOptions;
  const deliveryMethods = [...deliveries.deliveryMethods, ...deliveries.pickupMethods];
  const {
    hasShippingZipCodeError,
    hasShippingSubdivisionError,
    hasShippingDestinationError
  } = errors;
  const hasTimeSlots = deliveryMethods.some(opt => opt.hasTimeSlots);
  if (hasShippingSubdivisionError || hasShippingDestinationError || hasShippingZipCodeError || hasTimeSlots) {
    return;
  }
  const shippingOptions = deliveryMethods.map(_ref3 => {
    let {
      title,
      price,
      options,
      subtitle
    } = _ref3;
    const subOption = options[0];
    return {
      label: title,
      amount: price.toString(),
      identifier: subOption == null ? void 0 : subOption.id,
      detail: (subOption == null ? void 0 : subOption.deliveryTime) || subtitle || ''
    };
  });
  const selectedShippingOption = shippingOptions.findIndex(option => {
    var _checkout$shippingInf3;
    return option.identifier === ((_checkout$shippingInf3 = checkout.shippingInfo) == null || (_checkout$shippingInf3 = _checkout$shippingInf3.selectedCarrierServiceOption) == null ? void 0 : _checkout$shippingInf3.code);
  });
  if (selectedShippingOption !== -1) {
    shippingOptions.unshift(shippingOptions.splice(selectedShippingOption, 1)[0]);
  }
  return shippingOptions;
}
//# sourceMappingURL=getShippingMethods.js.map